module.exports = __webpack_public_path__ + "img/fa-v2-brands-400.8070c568.svg";